import Service from "./Service";

export default class ItemCategory {
	id: string;
	name: string;
	services: Array<Service>;
	displayOrder: number;
	subItemsIds: Array<string>;
	image: string;
	itemId: string;
	isFastTrack: boolean;
	hasSimpleOrderFlow: boolean;

	constructor() {
		this.services = new Array<Service>();
		this.subItemsIds = new Array<string>();
	}
}
